import { memo } from "react";
import styled from "@emotion/styled";
import { Loader } from "@kep-ui-kit/ui-components";

const StyledSpinnerContainer = styled('div')(() => ({
  position: 'absolute',
  display: 'flex',
  width: '100%',
  height: '100%',
  top: '0',
  left: '0',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  zIndex: 2147483647,
}));

const StyledSpinner = styled(Loader)(({ fullScreen }: { fullScreen?: boolean }) => ({
  width: 'fit-content',
  height: 'fit-content',
  ...(fullScreen && {
    margin: '-13px 0 0 -13px',
  }),
}));

interface Props {
  loading: boolean;
  fullScreen: boolean;
};

export const AdminSpinner = memo(({ loading, fullScreen = true }: Props) => {
  if (!loading) return null;

  return !fullScreen ? (
    <StyledSpinner size="large" />
  ) : (
    <StyledSpinnerContainer>
      <StyledSpinner size="large" fullScreen />
    </StyledSpinnerContainer>
  );
});
